/* eslint import/namespace: 0 */
import * as types from '../constants/actionTypes';
import * as chargeActions from '../actions/chargeActions';
import * as justAskActions from '../actions/justAskActions';
import { getAllServiceCallFeeOptions } from '../utils/helper';

const saveCharges = (store, action) => {

    const user = store
        .getState()
        .getIn(['user']);

    const charges = store
        .getState()
        .getIn(['workOrder', 'workOrderDetails', action.orderId, 'charges', 'details']);

    const accountNumber = store
        .getState()
        .getIn([
            'workOrder',
            'workOrderDetails',
            action.orderId,
            'orderDetails',
            'details',
            'accountNumber'
        ]);

    if (charges) {
        charges.forEach((item) => {

            if (item.get('action') === 'add') {

                if (item.get('isValid')) {
                    store.dispatch(chargeActions.chargeAddStarted({
                        userName: user.get('userId'),
                        jobNumber: action.orderId,
                        customerAccount: accountNumber,
                        comment: item.get('comment'),
                        quantity: item.get('quantity'),
                        billingSystemChargeID: item.get('billingSystemChargeID')

                    }, action.orderId));

                }

            }
            if (item.get('action') === 'update') {
                if (item.get('isValid')) {
                    store.dispatch(chargeActions.chargeUpdateStarted({
                        userName: user.get('userId'),
                        transactionID: item.get('transactionId'),
                        jobNumber: action.orderId,
                        customerAccount: accountNumber,
                        comment: item.get('comment'),
                        quantity: item.get('quantity'),
                        queueStatusTypeID: 1,
                        billingSystemChargeID: item.get('billingSystemChargeID')

                    }, action.orderId));
                }
            }

        });
    }

};

const saveJustAsk = (store, action) => {

    const justAskDetails = store
        .getState()
        .getIn(['workOrder', 'workOrderDetails', action.orderId, 'justAskDetails', 'details']);

    const accountNumber = store
        .getState()
        .getIn([
            'workOrder',
            'workOrderDetails',
            action.orderId,
            'orderDetails',
            'details',
            'accountNumber'
        ]);

    justAskDetails.forEach((item) => {

        if (item.get('action') === 'add') {

            store.dispatch(justAskActions.justAskAddStarted({
                jobNumber: action.orderId,
                customerAccount: accountNumber,
                quantity: item.get('quantity'),
                transactionTypeId: item.get('transactionTypeId')
            }, action.orderId));

        }
        if (item.get('action') === 'update') {
            store.dispatch(justAskActions.justAskUpdateStarted({
                jobNumber: action.orderId,
                customerAccount: accountNumber,
                quantity: item.get('quantity'),
                transactionID: item.get('transactionId'),
                queueStatusTypeID: 1,
                transactionTypeId: item.get('transactionTypeId')
            }, action.orderId));
        }

    });

};

const checkForSPPChange = (store, action) => {
    const charges = store
        .getState()
        .getIn(['workOrder', 'workOrderDetails', action.orderId, 'charges', 'details']);
    if (charges) {
        charges.forEach((item) => {
            if (
                item.get("chargeID") === action.chargeId &&
                item.get("chargeGroup") === "spp" &&
                (item.get("action") === "update" || item.get("action") === "add")
            ) {
                const chargeOptions = store.getState().getIn(['workOrder', 'workOrderDetails', action.orderId, 'charges']);
                const allServiceCallFees = getAllServiceCallFeeOptions(chargeOptions);
                const prevselectedItem = allServiceCallFees.find(serviceCallFee => {
                    return serviceCallFee.get('quantity') === 1;
                })
                if (item.get("startingQuantity") === 0 && action.quantity === 1) {
                    store.dispatch(chargeActions.chargeQuantitySet(prevselectedItem.get('chargeID'), 0, action.orderId));
                    store.dispatch(chargeActions.chargeQuantitySet(allServiceCallFees.last().get('chargeID'), 1, action.orderId))
                } 
            }
        });
    }
}

const middlewareHandler = (store, next, action) => {

    next(action);

    if (action.type === types.CHARGE_QUANTITY_SET) {
        checkForSPPChange(store, action);
        saveCharges(store, action);
    }

    if (action.type === types.JUST_ASK_QUANTITY_SET) {
        saveJustAsk(store, action);
    }

    if (action.type === types.CLOSE_ORDER_STATUS_SET) {
        saveJustAsk(store, action);
        saveCharges(store, action);
    }

};

export default function createQueueItemMiddleware() {

    return (store) => (next) => (action) => {
        middlewareHandler(store, next, action);
    };
}


// WEBPACK FOOTER //
// ./src/store/queueItemMiddleware.js